import React, { useEffect } from 'react';
import { BLADES } from '../../constants';
import GetStartedContainer from '../../containers/Blades/GetStartedContainer';
import YourDetailsContainer from '../../containers/Blades/YourDetailsContainer';
import AccountDetailsContainer from '../../containers/Blades/AccountDetailsContainer';
import { VisibilityState } from '../../stores/visibility/visibilityReducer';
import { scrollToAndFocusId } from '../../utils/scroller';
import SuccessPage from '../shared/SuccessPage/SuccessPage';
import ErrorPage from '../shared/ErrorPage/ErrorPage';

interface Props {
  visibility: VisibilityState;
  formInitialState: any;
}

const Page = ({ visibility, formInitialState }: Props) => {
  useEffect(() => {
    if (visibility) {
      // Find the blade with focus
      let bladeWithFocus = '';
      Object.keys(visibility).forEach((bladeName: string) => {
        if (visibility[bladeName].hasFocus) {
          bladeWithFocus = bladeName;
        }
      });
      // Scroll to the blade with focus if found
      if (bladeWithFocus.length > 0) {
        scrollToAndFocusId(bladeWithFocus);
      }
    }
  }, [visibility]);

  const { isSuccess, isFailure } = formInitialState;

  const isPageVisible = (!isSuccess && !isFailure);

  return (
    <>
      <div className="container pr-lg-5">
        {isPageVisible && (
          <div>
            <GetStartedContainer visibility={visibility[BLADES.getStarted].display} />
            <YourDetailsContainer visibility={visibility[BLADES.yourDetails].display} />
            <AccountDetailsContainer visibility={visibility[BLADES.accountDetails].display} />
          </div>
        )}
        {isSuccess && (
          <SuccessPage />
        )}
        {isFailure && (
          <ErrorPage />
        )}
      </div>
    </>
  );
};

export default Page;
